// AUTH ROUTES
const LOGIN_ROUTE = "/login";

const FORGOT_PASSWORD_ROUTE = "/forgot-password";

const RESET_PASSWORD_ROUTE = "/reset-password";

const EMAIL_SENT_ROUTE = "/email-sent"

const SIGNUP_ROUTE = "/sign-up";

const OTP_ROUTE = "/otp";

const CREATE_USER_ROUTE = "/create-account";

// NON-AUTH ROUTES
const TEST_ROUTE = "/test";
const NOT_FOUND_ROUTE = "/not-found";
const RESTRICTED_ROUTE = "/restricted";
const DESIGN_SYSTEM_ROUTE = "/ds";
const COMING_SOON_ROUTE = "/coming-soon";

const DEFAULT_ROUTE = "/";

const PROJECTS_ROUTE = "/projects";

const EXPLORE_APPS_ROUTE = "/explore-apps";

const LEARN_ROUTE = "/learn";

const PAYMENTS_ROUTE = "/pricing";







const REQUIREMENT_GATHERING_ROUTE = "/project/requirement-gathering";

const PROJECT_LAYOUT_ROUTE = "/project";

const UNIVERSAL_APP_BUILDER_ROUTE = "/project/:technology/:projectId";

const PROJECT_REACT_ROUTE = "/project/nextjs";

const PROJECT_STREAMLIT_ROUTE = "/project/streamlit";

const SHARED_APP_PATH = "/shared-project/:projectId";

const ADMIN_USER_LIST_PATH = "/admin/users";

const ADMIN_PROJECT_PATH = "/admin/project/:technology/:projectId";


const GUEST_ROUTES = [NOT_FOUND_ROUTE, DESIGN_SYSTEM_ROUTE, LOGIN_ROUTE, EXPLORE_APPS_ROUTE];



export {
    LOGIN_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    RESET_PASSWORD_ROUTE,
    EMAIL_SENT_ROUTE,
    OTP_ROUTE,
    COMING_SOON_ROUTE,
    NOT_FOUND_ROUTE,
    GUEST_ROUTES,
    SIGNUP_ROUTE,
    CREATE_USER_ROUTE,

    TEST_ROUTE,
    DESIGN_SYSTEM_ROUTE,
    RESTRICTED_ROUTE,
    DEFAULT_ROUTE,

    PROJECTS_ROUTE,
    EXPLORE_APPS_ROUTE,
    PAYMENTS_ROUTE,

    REQUIREMENT_GATHERING_ROUTE,
    PROJECT_LAYOUT_ROUTE,
    LEARN_ROUTE,
    PROJECT_REACT_ROUTE,
    PROJECT_STREAMLIT_ROUTE,
    SHARED_APP_PATH,
    UNIVERSAL_APP_BUILDER_ROUTE,
    ADMIN_USER_LIST_PATH,
    ADMIN_PROJECT_PATH
};
